import { NgRedux, select } from "@angular-redux/store";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { NGXLogger } from "ngx-logger";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { ChannelEventFactory } from "../../pb-screen/services/channel.event.factory";
import { ChannelService } from "../../pb-screen/services/channel.service";
import { ApplicationUser } from "../../pb-screen/models/application.user.interface";
import { SharedActions } from "../../shared/shared.actions";
import { SignalrListener } from "../../pb-screen/helpers/signalr.listener";
import { IAppState } from "../../store/IAppState";
import { UsersTableComponent } from "../containers/users-table/users-table.component";
import { UserAuthorizationActions } from "../user-authorization.actions";

import { SimpleModalService } from "ngx-simple-modal";
import { UpdateScreenAuthorizationComponent } from "../modals/update-screen-authorization/update-screen-authorization-modal.component";
import { UserAuthorization } from "../models/user-authorization.interface";
import { UsersAuthorizationService } from "../user-authorization.service";

declare var jQuery: any;
@Component({
    selector: "user-authorization",
    templateUrl: "./user-authorizations-view.component.html",
})
export class UserAuthorizationsViewComponent extends SignalrListener implements OnInit {

    @ViewChild("globalFilter", { static: true }) public globalFilter: ElementRef;
    @ViewChild("usersTable", { static: true }) public usersTable: UsersTableComponent;
    @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
    @select("selectedAzureUsers") public selectedAzureUsers$: Observable<any[]>;
    @ViewChild("usersTable",{static: true}) public ContainerPoolTable: UsersTableComponent; 
    public fallbackLanguage: string = "en";
    public languageToUse: string = "en";
    public user: ApplicationUser;
    public selectionCount: number = 0;

    public loaderEnabled: boolean = false;
    constructor(
        ngRedux: NgRedux<IAppState>,
        channelService: ChannelService,
        channelEventFactory: ChannelEventFactory,
        ngxLogger: NGXLogger,
        private readonly translate: TranslateService,
        private readonly toastr: ToastrService,
        private readonly titleService: Title,
        sharedActions: SharedActions,
        private readonly usersService: UsersAuthorizationService,
        private readonly userAuthorizationActions: UserAuthorizationActions,
        private simpleModalService: SimpleModalService,

    ) {

        super(ngRedux, sharedActions, channelEventFactory, channelService, ngxLogger);

    }

    ngOnInit(): void {
        this.initialize().then(() => {
        this.loaderEnabled = true;
        this.titleService.setTitle("Authorizations");
        super.initialize();
        this.sharedActions.getMonitorServiceStatus();
        this.applicationUser$.subscribe((user) => {
            if (user !== null) {
                this.user = user;
            }
        })


        this.usersService.getAllUsers().subscribe((data) => {
            this.userAuthorizationActions.setAllUsers(data);
            this.loaderEnabled = false;
        })

        this.selectedAzureUsers$.subscribe((data) => {
            if (data) {
                this.selectionCount = data.length;
            }
        })
    } );}
    

    public collapseBox(name) {
        (function ($) {
            var chevron = document.getElementsByClassName('collapse-link-' + name)[0];
            var ibox = $(chevron).closest('div.ibox');
            var button = $(chevron).find('i');
            var content = ibox.find('div.ibox-content');
            content.slideToggle(200);
            button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
            ibox.toggleClass('').toggleClass('border-bottom');
            ibox.resize();
            setTimeout(function () {
                ibox.resize();
                ibox.find('[id^=map-]').resize();
            }, 50);


        })(jQuery);
    }


    // public openModal(modalId: string): void {
    //     if (modalId) {
    //         this.modalManager.openModal(modalId);
    //     }
    // }

    openUpdateScreenAuthorization() {
        this.simpleModalService.addModal(UpdateScreenAuthorizationComponent, 
        ).subscribe(() => {
        });
    }

    public resetSelection() {
        this.userAuthorizationActions.setSelectedAzureUsers([]);
    }

    
    public filterUsers(selectedText: string): void {
        this.userAuthorizationActions.filterUsers(selectedText);
        this.usersTable.refreshTableDisplay();
    }

    public clearGobalFilter(): void {
        this.globalFilter.nativeElement.value = "";
        this.userAuthorizationActions.filterUsers(""); 
        this.usersTable.refreshTableDisplay();
      
    }

}